/* istanbul ignore next */
if (typeof rcm != 'undefined') {
    // RCM is undefined in unit tests
    rcm.addAngularModule('app-ui-switch-user');
}
angular.module('app-ui-switch-user', ['pascalprecht.translate', 'pipe-rat-js', 'app-ui-profile']);
